<div class="container-tooltip" [style.top.px]="buttonPosition()" (click)="$event.stopPropagation();"
    [ngStyle]="{'display': openTooltip() ? 'flex' : 'none'}">
    <div id="tooltip-header">
        <div (click)="dialogClose()">
            <div class="close-icon"></div>
        </div>
    </div>

    <app-ui-description-items-service
      [title]="title()"
      [description]="description()"
      [label]="label()"
      [subtitleColor]="subtitleColor()"
    />
</div>
